/**
 * イベント予約: #store-select 直下のインライン日付・時間帯選択 + モーダル step1 へ遷移
 */
(function () {
  const LOCALE = {
    days: ['日', '月', '火', '水', '木', '金', '土'],
    daysShort: ['日', '月', '火', '水', '木', '金', '土'],
    daysMin: ['日', '月', '火', '水', '木', '金', '土'],
    months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    monthsShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    today: '今日',
    clear: 'クリア',
    dateFormat: 'yyyy-MM-dd',
    timeFormat: 'hh:mm aa',
    firstDay: 0,
  };

  const NAV_PREV =
    '<button type="button"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 20L16.2929 19.2929L15.5858 20L16.2929 20.7071L17 20ZM23.7071 25.2929L17.7071 19.2929L16.2929 20.7071L22.2929 26.7071L23.7071 25.2929ZM17.7071 20.7071L23.7071 14.7071L22.2929 13.2929L16.2929 19.2929L17.7071 20.7071Z" fill="#555"/></svg></button>';
  const NAV_NEXT =
    '<button type="button"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23 20L23.7071 19.2929L24.4142 20L23.7071 20.7071L23 20ZM16.2929 25.2929L22.2929 19.2929L23.7071 20.7071L17.7071 26.7071L16.2929 25.2929ZM22.2929 20.7071L16.2929 14.7071L17.7071 13.2929L23.7071 19.2929L22.2929 20.7071Z" fill="#555"/></svg></button>';

  let datepickerInstance = null;
  let filteredTickets = [];
  let selectedIsoDate = null;

  function parseTicketJson() {
    const el = document.querySelector('#filtered-ticket-data');
    if (!el || !el.dataset.ticketJson) return [];
    try {
      return JSON.parse(el.dataset.ticketJson);
    } catch (e) {
      console.error('event-reservation-inline: invalid ticket JSON', e);
      return [];
    }
  }

  function getStoreNameFromSelect() {
    const sel = document.getElementById('store-select');
    if (!sel || !sel.value) return '';
    const opt = sel.options[sel.selectedIndex];
    return opt ? opt.text.trim() : '';
  }

  function filterByStore(tickets, storeName) {
    return tickets.filter(function (t) {
      const venue = t.event_data && t.event_data.venue ? t.event_data.venue.name : '';
      return venue === storeName || (venue === 'EC倉庫' && storeName === 'オンライン');
    });
  }

  function hasReservationEnd(ticket) {
    var v = ticket.reservation_end_date_time;
    return v !== '' && v != null && v !== undefined;
  }
  function hasReservationStart(ticket) {
    var v = ticket.reservation_start_date_time;
    return v !== '' && v != null && v !== undefined;
  }

  function ticketDisabled(ticket, now) {
    let ended = now > new Date(ticket.event_data.starts_at);
    if (hasReservationEnd(ticket)) {
      ended = now > new Date(ticket.reservation_end_date_time);
    }
    let reservationOpened = true;
    if (hasReservationStart(ticket)) {
      reservationOpened = now > new Date(ticket.reservation_start_date_time);
    }
    const reserved = String(ticket.customer_has_reserved) === 'true';
    const unavailable = String(ticket.available) === 'false';
    return reserved || unavailable || ended || !reservationOpened;
  }

  function ticketStatusLabel(ticket, now) {
    let ended = now > new Date(ticket.event_data.starts_at);
    if (hasReservationEnd(ticket)) {
      ended = now > new Date(ticket.reservation_end_date_time);
    }
    let reservationOpened = true;
    if (hasReservationStart(ticket)) {
      reservationOpened = now > new Date(ticket.reservation_start_date_time);
    }
    const reserved = String(ticket.customer_has_reserved) === 'true';
    const unavailable = String(ticket.available) === 'false';
    const disabledClass = reserved || unavailable || ended || !reservationOpened ? 'modal-event__date--disabled' : '';
    if (ended) return { label: '受付終了', disabled: true, rowClass: disabledClass };
    if (!reservationOpened) return { label: '予約開始前', disabled: true, rowClass: disabledClass };
    if (reserved) return { label: '予約済み', disabled: true, rowClass: disabledClass };
    if (unavailable) return { label: '満席', disabled: true, rowClass: disabledClass };
    const stock = parseInt(ticket.stock, 10) || 0;
    return { label: '残り' + stock + '組', disabled: false, rowClass: '', low: stock <= 1 };
  }

  function isoFromEventDate(dateStr) {
    if (!dateStr) return '';
    return String(dateStr).replace(/\//g, '-');
  }

  function todayIso() {
    const d = new Date();
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }

  /** 開催日が今日より前の枠を除く（当日の枠は残し、時間を過ぎたものは「受付終了」で表示） */
  function excludePastDates(tickets) {
    const today = todayIso();
    return tickets.filter(function (t) {
      const iso = isoFromEventDate(t.event_data && t.event_data.date);
      return !iso || iso >= today;
    });
  }

  function ticketsForIsoDate(tickets, iso) {
    return tickets.filter(function (t) {
      return isoFromEventDate(t.event_data.date) === iso;
    });
  }

  /** 店舗フィルタ後、その日にイベント枠（バリアント）が1件でもある */
  function dateHasAnyTicketForDate(tickets, iso) {
    return ticketsForIsoDate(tickets, iso).length > 0;
  }

  /** その日に予約可能な枠が1つでもある */
  function dateHasAnyBookableSlot(tickets, iso, now) {
    return ticketsForIsoDate(tickets, iso).some(function (t) {
      return !ticketDisabled(t, now);
    });
  }

  function destroyCalendar() {
    if (datepickerInstance && typeof datepickerInstance.destroy === 'function') {
      datepickerInstance.destroy();
    }
    datepickerInstance = null;
    const host = document.getElementById('event-inline-calendar-input');
    if (host && host.parentNode) {
      host.parentNode.querySelectorAll('.air-datepicker').forEach(function (n) {
        return n.remove();
      });
    }
  }

  function renderTimeSlots() {
    const ul = document.getElementById('event-inline-time-slots');
    if (!ul) return;
    ul.innerHTML = '';
    if (!filteredTickets.length) {
      ul.innerHTML = '<li class="event-inline-reservation__time-empty">現在ご予約いただける日程はありません</li>';
      return;
    }
    if (!selectedIsoDate) {
      ul.innerHTML = '<li class="event-inline-reservation__time-empty">日付を選択してください</li>';
      return;
    }
    const now = new Date();
    let list = ticketsForIsoDate(filteredTickets, selectedIsoDate);
    list = list.slice().sort(function (a, b) {
      return new Date(a.event_data.starts_at) - new Date(b.event_data.starts_at);
    });
    if (list.length === 0) {
      ul.innerHTML = '<li class="event-inline-reservation__time-empty">この日の枠はありません</li>';
      return;
    }
    list.forEach(function (ticket) {
      const st = ticketStatusLabel(ticket, now);
      const li = document.createElement('li');
      if (!st.disabled) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'event-inline-reservation__time-slot';
        btn.dataset.variantId = String(ticket.variant);

        const timeEl = document.createElement('div');
        timeEl.className = 'event-inline-reservation__time-range';
        timeEl.textContent = ticket.time || '';

        const statusEl = document.createElement('div');
        statusEl.className = 'event-inline-reservation__time-status' + (st.low ? ' event-inline-reservation__time-status--low' : '');
        statusEl.textContent = st.label;

        const ctaEl = document.createElement('div');
        ctaEl.className = 'event-inline-reservation__book';
        ctaEl.textContent = '予約する';

        btn.appendChild(timeEl);
        btn.appendChild(statusEl);
        btn.appendChild(ctaEl);

        btn.addEventListener('click', function () {
          onBookClick(String(ticket.variant));
        });

        li.appendChild(btn);
      } else {
        const row = document.createElement('div');
        row.className = 'event-inline-reservation__time-slot event-inline-reservation__time-slot--disabled';

        const timeEl = document.createElement('div');
        timeEl.className = 'event-inline-reservation__time-range';
        timeEl.textContent = ticket.time || '';

        const statusEl = document.createElement('div');
        statusEl.className = 'event-inline-reservation__time-status' + (st.low ? ' event-inline-reservation__time-status--low' : '');
        statusEl.textContent = st.label;

        row.appendChild(timeEl);
        row.appendChild(statusEl);
        li.appendChild(row);
      }
      ul.appendChild(li);
    });
  }

  function openModalThenGoToStep1(variantId) {
    const opener = document.getElementById('to-date-modal-button');
    if (!opener) return;
    opener.click();

    var attempts = 0;
    function tick() {
      attempts++;
      const radio = document.getElementById(variantId);
      const nextBtn = document.getElementById('to-customer-modal-button');
      if (radio && nextBtn) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        if (!nextBtn.disabled) {
          nextBtn.click();
          return;
        }
      }
      if (attempts < 120) {
        setTimeout(tick, 50);
      } else {
        console.warn('event-reservation-inline: could not advance to customer step');
      }
    }
    setTimeout(tick, 0);
  }

  function onBookClick(variantId) {
    const loggedIn = document.getElementById('event-inline-reservation');
    const isCustomer = loggedIn && loggedIn.getAttribute('data-customer-logged-in') === 'true';
    if (!isCustomer) {
      const loginBtn = document.getElementById('to-date-modal-button');
      if (loginBtn) loginBtn.click();
      return;
    }
    openModalThenGoToStep1(variantId);
  }

  function buildCalendar() {
    const wrap = document.getElementById('event-inline-reservation');
    const input = document.getElementById('event-inline-calendar-input');
    const host = document.getElementById('event-inline-calendar-host');
    if (!wrap || !input || !host || typeof window.AirDatepicker !== 'function') return;

    destroyCalendar();

    if (!filteredTickets.length) {
      // 入力欄（#event-inline-calendar-input）は消さない。消すと次に店舗を選び直したときにカレンダーを作れなくなる
      selectedIsoDate = null;
      renderTimeSlots();
      return;
    }

    const dates = filteredTickets
      .map(function (t) {
        return t.event_data.date;
      })
      .filter(Boolean)
      .sort();
    const minIso = isoFromEventDate(dates[0]);
    const maxIso = isoFromEventDate(dates[dates.length - 1]);
    const minDate = new Date(minIso + 'T12:00:00');
    const maxDate = new Date(maxIso + 'T12:00:00');
    const now = new Date();

    datepickerInstance = new window.AirDatepicker(input, {
      inline: true,
      locale: LOCALE,
      minDate: minDate,
      maxDate: maxDate,
      isMobile: false,
      navTitles: {
        days: 'yyyy<span>年</span> M<span>月</span>',
      },
      prevHtml: NAV_PREV,
      nextHtml: NAV_NEXT,
      onRenderCell: function (data) {
        if (data.cellType !== 'day') return {};
        const y = data.date.getFullYear();
        const m = String(data.date.getMonth() + 1).padStart(2, '0');
        const d = String(data.date.getDate()).padStart(2, '0');
        const iso = y + '-' + m + '-' + d;
        if (!dateHasAnyTicketForDate(filteredTickets, iso)) {
          return { disabled: true };
        }
        if (!dateHasAnyBookableSlot(filteredTickets, iso, now)) {
          return { classes: 'event-inline-calendar__day--full' };
        }
        return {};
      },
      onSelect: function (sel) {
        if (!sel.date) return;
        const y = sel.date.getFullYear();
        const m = String(sel.date.getMonth() + 1).padStart(2, '0');
        const d = String(sel.date.getDate()).padStart(2, '0');
        selectedIsoDate = y + '-' + m + '-' + d;
        renderTimeSlots();
      },
    });

    // 最初に選ぶ日：予約できる枠がある一番近い日。無ければ一番近い日
    var firstSelectable = null;
    for (var i = 0; i < filteredTickets.length; i++) {
      var iso = isoFromEventDate(filteredTickets[i].event_data.date);
      if (iso && dateHasAnyBookableSlot(filteredTickets, iso, now)) {
        firstSelectable = iso;
        break;
      }
    }
    if (!firstSelectable) firstSelectable = minIso || null;
    if (firstSelectable) {
      selectedIsoDate = firstSelectable;
      datepickerInstance.selectDate(new Date(firstSelectable + 'T12:00:00'), { silent: true });
    } else {
      selectedIsoDate = null;
    }
    renderTimeSlots();
  }

  function refreshForStore() {
    const wrap = document.getElementById('event-inline-reservation');
    const storeSelect = document.getElementById('store-select');
    if (!wrap || !storeSelect) return;

    if (!storeSelect.value || !getStoreNameFromSelect()) {
      wrap.hidden = true;
      destroyCalendar();
      filteredTickets = [];
      selectedIsoDate = null;
      renderTimeSlots();
      return;
    }

    wrap.hidden = false;
    const all = parseTicketJson();
    filteredTickets = excludePastDates(filterByStore(all, getStoreNameFromSelect()));
    buildCalendar();
  }

  /** 今日以降に開催がない店舗を、店舗の選択肢から外す（RENEW-72） */
  function removeStoresWithoutEvents() {
    const storeSelect = document.getElementById('store-select');
    if (!storeSelect) return;
    const all = parseTicketJson();
    Array.prototype.slice.call(storeSelect.options).forEach(function (opt) {
      if (!opt.value) return; // 「開催店舗を選ぶ」は残す
      if (!excludePastDates(filterByStore(all, opt.text.trim())).length) {
        opt.remove();
      }
    });
  }

  function waitForTicketsAndInit() {
    function tryInit() {
      const el = document.querySelector('#filtered-ticket-data');
      if (el && el.dataset.ticketJson) {
        removeStoresWithoutEvents();
        refreshForStore();
        return true;
      }
      return false;
    }
    if (tryInit()) return;
    var n = 0;
    var id = setInterval(function () {
      n++;
      if (tryInit() || n > 100) clearInterval(id);
    }, 50);
  }

  function boot() {
    const storeSelect = document.getElementById('store-select');
    if (storeSelect) {
      storeSelect.addEventListener('change', refreshForStore);
    }
    waitForTicketsAndInit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

